import React, { FC, MutableRefObject } from 'react';
import classNames from 'classnames';
import { makeStyles } from 'tss-react/mui';

import TextField from '@mui/material/TextField';

import { transactionsTypes } from 'companion-app-components/flux/transactions';

import { isC2RTransaction } from 'data/transactions/utils';
import QTip from 'components/QuickenControls/QTip';
import QTypography from 'components/MUIWrappers/QTypography';

import { RegListItem, styles } from '../styles';

import type { AttributesType, CallbacksType } from '../types';

const useStyles = makeStyles()(styles as Record<string, any>);

interface NotesFieldProps {
  attributes: AttributesType;
  forceStatic: boolean;
  callbacks: CallbacksType;
  editable: boolean;
  SHOW_ALL: boolean;
  txn: transactionsTypes.CashFlowTransaction;
  wrapClass: string; 
  editClass: string; 
  hoverClass: string;
  currEditFieldName: string;
  enableAutoFocus: boolean;
  wrapText: string | React.JSX.Element;
  field: string;
  staticValue: string | React.JSX.Element;
  focusField: MutableRefObject<HTMLAnchorElement | null>;
}

const NotesField: FC<NotesFieldProps> = ({
  attributes,
  forceStatic,
  callbacks,
  editable,
  SHOW_ALL,
  txn,
  wrapClass,
  editClass,
  hoverClass,
  currEditFieldName,
  enableAutoFocus,
  wrapText,
  field,
  staticValue,
  focusField,
}) => {
  const { classes, theme } = useStyles();
  const c2RTxnClass = isC2RTransaction(txn) ? classes.txnInC2RText : '';
  return (
    <RegListItem
      {...attributes}
      className={classNames(classes.regItem, 'flex2', wrapClass, editClass, hoverClass, c2RTxnClass)}
    >
      {SHOW_ALL &&
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <>
        {editable && !forceStatic && currEditFieldName === 'notes' ?
          <TextField
            variant="standard"
            // @ts-expect-error: Property 'register' does not exist on type 'Components<BaseTheme>'.
            InputProps={{ disableUnderline: theme.components?.register.noUnderline }}
            className={classes.regInput}
            onFocus={callbacks.handleFocus}
            autoFocus={enableAutoFocus}
            placeholder="Memo"
            value={txn.memo || ''}
            onChange={(e) => callbacks.handleChange?.(e, 'notes')}
            // onBlur={(e) => onFieldBlur(e, 'notes')}
            inputRef={(input) => {
              focusField.current = input; // eslint-disable-line
            }}
          >
          </TextField> :
          // @ts-expect-error: missing props
          <QTip
            wrapOnly
            title={wrapText ? null : txn.memo}
            wrapId={`${txn.id}-${field}`}
          >
            <QTypography
              clickable={!forceStatic ? 'true' : null}
              thinFont
              className={classes.regItemCore}
            >
              {txn.memo || staticValue}
            </QTypography>
          </QTip>}
      </>}
    </RegListItem>
  );
};

export default NotesField;
